/* eslint-disable prefer-destructuring */
import {isPlatformBrowser} from '@angular/common';
import {Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Subscription} from 'rxjs';
import {AppState} from 'src/app/app.reducer';
import {PrimeConfig, PrimeSubscription} from 'src/app/data/networking/models/prime/prime';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';
import {BrowserDetectorService} from 'src/app/data/networking/services/shared/broswer-detector/browser-detector.service';
import {ProductCardVm} from 'src/app/view-model/product-card/product-card.vm';

@Component({
  selector: 'app-product-card-group',
  templateUrl: './product-card-group.component.html',
  styleUrls: ['./product-card-group.component.scss'],
})
export class ProductCardGroupComponent implements OnInit, OnDestroy {
  constructor(
    private vm: ProductCardVm,
    private router: Router,
    private browserDetectorService: BrowserDetectorService,
    private store: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.checkIfResponsive(this.platformId);
  }

  @Input() product: ProductInterface;
  @Input() lazyLoaded = false;
  @Input() isHome = false;
  @Input() isFavorite = false;
  @Input() isOffer = false;
  @Input() groupType = '';
  @Input() columnHalf = false;

  browser = this.browserDetectorService.checkBrowser();
  isBrowser: boolean;
  isResponsive: boolean;
  urlGo: string;
  primeConfigSubs: Subscription;
  primeStyles: PrimeConfig;
  primeData: PrimeSubscription;

  ngOnInit(): void {
    if (this.product?.type === 'GROUP') {
      this.urlGo = this.product?.url;
    } else {
      this.urlGo = this.product?.url
        ? `/producto/${this.product?.url}`
        : `/producto/${this.product?.id}-${this.product?.seoUrl}`;
    }

    this.getPrimeData();
  }

  get highlighted() {
    return this.groupType === 'highlights';
  }

  get suggestedHalf() {
    return this.columnHalf && this.groupType === 'suggests';
  }

  get suggestedFull() {
    return !this.columnHalf && this.groupType === 'suggests';
  }

  checkIfResponsive(platformId) {
    const mobileWidth = 786;
    this.isBrowser = isPlatformBrowser(platformId) && navigator.userAgent.indexOf('Chrome-Lighthouse') <= -1;
    this.lazyLoaded = this.isBrowser && this.lazyLoaded;
    this.isResponsive = this.isBrowser && window.screen.width <= mobileWidth;
  }

  goToGroup() {
    const isGroup = this.product?.type === 'GROUP';
    if (this.product.deepLinkRedirectUrl && isGroup && this.isBrowser) {
      window.open(this.product.deepLinkRedirectUrl, '_self');
      return;
    }

    if (this.product?.url && !this.product.deepLinkRedirectUrl) {
      this.router.navigate([this.product?.url]);
    }
  }

  getPrimeData() {
    this.primeConfigSubs = this.store.select('prime').subscribe(({config}) => {
      if (!config?.length) return;

      this.primeStyles = config[0];
      this.vm.getPrimeSubscription().subscribe(res => {
        this.primeData = res;
        this.validateSubscription(res.expirationDate ? res.expirationDate : '');
      });
    });
  }

  validateSubscription(expirationDate) {
    if (expirationDate) {
      const today = new Date().getTime();
      this.primeData.active = Boolean(expirationDate >= today);
    }
    if (!this.primeStyles?.feature_active_web && !this.primeData.active) {
      this.product.primeDescription = null;
      this.product.primePrice = null;
      this.product.primeTextDiscount = null;
    }
  }

  primeOffer(): boolean {
    const primeActive = this.product.primeTextDiscount && this.primeData?.active;

    return primeActive;
  }

  ngOnDestroy(): void {
    this.primeConfigSubs?.unsubscribe();
  }
}
